export function get(url, cb) {
  dispatch(url, 'GET', null, cb)
}

export function post(url, object, cb) {
  dispatch(url, 'POST', object, cb)
}

function dispatch(url, method, object, cb) {
  const xhr = new XMLHttpRequest()
  xhr.open(method, url, true)
  xhr.responseType = 'arraybuffer'
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      if (xhr.status !== 200) {
        cb(xhr.status, xhr.response)
      } else if (xhr.response && xhr.response.byteLength > 0) {
        cb(false, xhr.response)
      } else {
        if (xhr.response && xhr.response.byteLength === 0)
          return cb('response length 0')
        cb('no response')
      }
    }
  }
  if (object) {
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send(JSON.stringify(object))
  } else {
    xhr.send(null)
  }
}
